module.exports = __webpack_public_path__ + "static/media/poi_SESUnits_multi.fa6ad9fd.svg";